import React from 'react';
import toast, { Toaster } from 'react-hot-toast';

import {confirmAlert} from "react-confirm-alert";
import Role from "../../inc/Role";
import {NavLink, useNavigate} from "react-router-dom";
import * as Icon from "react-bootstrap-icons";
import {Config} from '../../Config'
import moment from "moment-timezone";
import * as Utils from "../../inc/Utils";
import Select from 'react-select'
import {getKol} from "../../inc/Utils";
import DatePicker from "react-datepicker";
import {getOwnerRunningId} from "../../inc/Utils";
import {getOwnerRunningCode} from "../../inc/Utils";

export default function GenerateSpecialMultiple() {
    const roles = new Role();
    let userId = roles.loginUserId;

    let btnTextDefault = 'บันทึกข้อมูล';
    let btnTextLoading = 'กำลังบันทึก..';
    let [isLoading, setLoading] = React.useState(false);
    let [buttonText, setButtonText] = React.useState(btnTextDefault);
    const navigate = useNavigate();

    let [lang, setLanguage] = React.useState(null);
    let [langId, setLanguageId] = React.useState(null);
    let [projectType, setProjectType] = React.useState(null);
    let [projectTypeId, setProjectTypeId] = React.useState(null);
    let [campaign, setCampaign] = React.useState(null);
    let [campaignId, setCampaignId] = React.useState(null);
    let [agency, setAgency] = React.useState(null);
    let [platform, setPlatform] = React.useState(null);
    let [platformId, setPlatformId] = React.useState(null);

    let [campaignPlaceholder, setCampaignPlaceholder] = React.useState('...');

    let [disableCampaign, setDisableCampaign] = React.useState(true);
    let [disableTemplate, setDisableTemplate] = React.useState(true);

    let [campaignTemplate, setCampaignTemplate] = React.useState(null);
    let [campaignTemplateId, setCampaignTemplateId] = React.useState(null);

    let [generateTypeCampaign, setGenerateTypeCampaign] = React.useState(false);
    let [generateTypeAdsSet, setGenerateTypeAdsSet] = React.useState(false);
    let [generateTypeUTM, setGenerateTypeUTM] = React.useState(false);

    let [isCustomUrl, setIsCustomUrl] = React.useState(false);
    let [slugDisabled, setSlugDisabled] = React.useState(true);

    let [specialFilterId, setSpecialFilterId] = React.useState(null);
    let [specialFilter, setSpecialFilter] = React.useState(null);
    let [zoneStatus, setZoneStatus] = React.useState(null);
    let [zoneStatusId, setZoneStatusId] = React.useState(null);
    let [eventDate, setEventDate] = React.useState(null);

    let [bgZoneId, setBgZoneId] = React.useState(null);
    let [bgZone, setBgZone] = React.useState(null);
    let [bgZonePlaceholder, setBgZonePlaceholder] = React.useState('Select...');

    let [combineZoneId, setCombineZoneId] = React.useState(null);
    let [combineZone, setCombineZone] = React.useState(null);
    let [combineZonePlaceholder, setCombineZonePlaceholder] = React.useState('Select...');

    let [eventReminderId, setEventReminderId] = React.useState(null);
    let [eventReminder, setEventReminder] = React.useState(null);
    let [eventReminderPlaceholder, setEventReminderPlaceholder] = React.useState('Select...');

    let [staticPageId, setStaticPageId] = React.useState(null);
    let [staticPage, setStaticPage] = React.useState(null);
    let [staticPagePlaceholder, setStaticPagePlaceholder] = React.useState('Select...');

    let refUrl = React.useRef();
    let refCampaignSlug = React.useRef();
    let refAdssetSlug = React.useRef();

    React.useEffect(() => {
        (async function() {
            try {
                setGenerateTypeCampaign(true);

                setDisableTemplate(true);
                const resTemplate = await Utils.getCampaignTemplate(Utils.GENERATE_TYPE_SPECIAL);
                if(isCustomUrl) {
                    setCampaignTemplate(resTemplate.filter(e => e.isCustomUrl === 1));
                }
                else {
                    setCampaignTemplate(resTemplate.filter(e => e.isCustomUrl === null));
                }
                setDisableTemplate(false);

                const resPlatform = await Utils.getPlatformAll();
                setPlatform(resPlatform);

                const resLanguage = await Utils.getLanguage();
                setLanguage(resLanguage);

                const resFilter = await Utils.getAdsNamingSpecialFilter();
                setSpecialFilter(resFilter);
                const resZoneStatus = await Utils.getAdsNamingZoneStatus();
                setZoneStatus(resZoneStatus);
                const resProjectType = await Utils.getProjectType();
                setProjectType(resProjectType);

                const resAgency = await Utils.getAgencySlug();
                let newAgencies = [];
                if(resAgency) {
                    let newA = resAgency.find(e => e.id === roles.agencyId).items;
                    let ownerIds = [];
                    for(let a of newA) {
                        ownerIds.push(a.ownerId);
                    }
                    for(let ag of resAgency) {
                        if(ag.items.find(e => ownerIds.includes(e.ownerId))) {
                            newAgencies.push({
                                id: ag.id,
                                slug: ag.slug,
                                name: ag.name
                            })
                        }
                    }
                }
                if(roles.permissionId !== Utils.SUPER_ADMIN_ID && roles.agencyId) {
                    newAgencies = newAgencies.filter(e => e.id === roles.agencyId);
                }
                setAgency(newAgencies);

                setCampaignPlaceholder('กำลังโหลด...');
                setDisableCampaign(true);
                let newCampaign = [];
                const resCampaign = await Utils.getListSubCampaign();
                if(resCampaign) {
                    let campaignList = resCampaign.campaign;
                    if(campaignList) {
                        for(let rs of campaignList) {
                            newCampaign.push({
                                campaign_id: rs.sub_campaign_id,
                                campaign_name: rs.sub_campaign_name
                            })
                        }
                        setCampaign(newCampaign);
                        setCampaignPlaceholder('Select...');
                        setDisableCampaign(false);
                    }
                }
                else {
                    setCampaign(null);
                    setCampaignPlaceholder('ไม่พบข้อมูล..');
                }

                //-- Campaign
                await campaignDetail();

                //-- AdsSet
                await adssetDetail();

                //-- UTM
                await utmDetail();

            } catch (e) {
                toast.error(e.message);
            }
        })();
    }, []);

    const onCreate = async () => {
        let campaignParam = [];
        let generateTypeCampaignValidate = {};
        if(generateTypeCampaign && generateGroupCampaign.length > 0) {
            for(let n=0;n<generateGroupCampaign.length;n++) {
                let param = await getCampaignParams(n);
                if(param.params.length > 200) {
                    generateTypeCampaignValidate.message = 'Campaign Parameters [' + generateGroupCampaign[n].name + '] ขนาดตัวอักษรต้องไม่เกิน 200';
                    break;
                }
                else if(!param.success) {
                    generateTypeCampaignValidate.message = 'กรุณาเลือก Campaign Parameters [' + generateGroupCampaign[n].name + '] ให้ครบถ้วน';
                    break;
                }
                else {
                    campaignParam[n] = param;
                }
            }
        }

        let adssetParams = [];
        let generateTypeAdsSetValidate = {};
        if (generateTypeAdsSet && generateGroupCampaign.length > 0) {
            for (let n=0;n<generateGroupCampaign.length;n++) {
                adssetParams[n] = [];
                if (generateGroupCampaign[n].masterAdssetItems && generateGroupCampaign[n].masterAdssetItems.length > 0) {
                    for (let idx = 0; idx < generateGroupCampaign[n].masterAdssetItems.length; idx++) {
                        adssetParams[n][idx] = [];
                        const param = await getAdssetParams(n, idx);
                        let selectedSetNameType = document.getElementsByName('selectedAdsNamingSetNameType[' + n + '][' + idx + ']');
                        if (param.params.length > 200) {
                            generateTypeAdsSetValidate.message = 'Ads Set Parameters [' + generateGroupCampaign[n].name + '][ตัวที่ ' + (idx + 1) + '] ขนาดตัวอักษรต้องไม่เกิน 200';
                            break;
                        }
                        else if (!param.success) {
                            generateTypeAdsSetValidate.message = 'กรุณาเลือก Ads Set Parameters [' + generateGroupCampaign[n].name + '][ตัวที่ ' + (idx + 1) + '] ให้ครบถ้วน';
                            break;
                        }
                        else if (!selectedSetNameType || selectedSetNameType && !selectedSetNameType[0].value) {
                            generateTypeAdsSetValidate.message = 'Ads Set Parameters [' + generateGroupCampaign[n].name + '] กรุณาระบุ Type';
                            break;
                        }
                        else {
                            adssetParams[n][idx] = param;
                        }
                    }
                }
            }
        }

        let utmParams = [];
        let generateTypeUTMValidate = {};
        if (generateTypeUTM && generateGroupCampaign.length > 0) {
            setLoading(true);
            setButtonText('กำลังตรวจสอบ UTM...');
            for (let n=0;n<generateGroupCampaign.length;n++) {
                utmParams[n] = [];
                if (generateGroupCampaign[n].masterUtmItems && generateGroupCampaign[n].masterUtmItems.length > 0) {
                    for (let idx = 0; idx < generateGroupCampaign[n].masterUtmItems.length; idx++) {
                        utmParams[n][idx] = [];
                        let sourceTypeIds = [];
                        let selectSourceTypeIds = document.getElementsByName('sourceTypeIds['+n+'][' + idx + '][]');
                        let ownerSelectedId = 0;
                        let ownerSelectedCode = 0;
                        let ownerFullText = '';
                        if (selectSourceTypeIds) {
                            for (let st of selectSourceTypeIds) {
                                if (st.value) {
                                    let utmSourceTypeId = st.value;
                                    let utmSourceId = 0;
                                    let utmSourceTypeText = null;
                                    let inputType = null;

                                    if (utmSourceTypeId.includes(':CID')) {
                                        let sp = utmSourceTypeId.split(':CID');
                                        let contentId = sp[0];
                                        utmSourceId = sp[1];
                                        let contentView = await Utils.getContentIdView(contentId);
                                        utmSourceTypeText = Utils.contentIdGenerater(contentView);
                                        utmSourceTypeId = contentId;
                                        inputType = Utils.API_TYPE_CONTENT_ID;
                                    }
                                    else if (utmSourceTypeId.includes(':OID')) {
                                        let sp = utmSourceTypeId.split(':OID');
                                        let ownerId = sp[0];
                                        utmSourceId = sp[1];
                                        let resOwner = await Utils.getOwnerView(ownerId);
                                        let ownerCodeRow = await getOwnerRunningId(ownerId);
                                        utmSourceTypeText = getOwnerRunningCode(resOwner.code, ownerCodeRow.code ?? 1);
                                        utmSourceTypeId = ownerId;
                                        inputType = Utils.API_TYPE_OWNER_ID;
                                        ownerSelectedId = ownerId;
                                        ownerSelectedCode = ownerCodeRow.code;
                                        ownerFullText = utmSourceTypeText;
                                    }
                                    else if (utmSourceTypeId.includes(':CP')) {
                                        let sp = utmSourceTypeId.split(':CP');
                                        let campaignId = sp[0];
                                        utmSourceId = sp[1];
                                        utmSourceTypeText = campaignId;
                                        utmSourceTypeId = 0;
                                        inputType = Utils.API_TYPE_CAMPAIGN_ID;
                                    }
                                    else if (utmSourceTypeId.includes(':CN')) {
                                        let sp = utmSourceTypeId.split(':CN');
                                        let campaignName = sp[0];
                                        utmSourceId = sp[1];
                                        utmSourceTypeText = campaignName;
                                        utmSourceTypeId = 0;
                                        inputType = Utils.API_TYPE_CAMPAIGN_NAME;
                                    }
                                    else if (utmSourceTypeId.includes(':PJI')) {
                                        let sp = utmSourceTypeId.split(':PJI');
                                        let projectCode = sp[0];
                                        utmSourceId = sp[1];
                                        utmSourceTypeText = projectCode;
                                        utmSourceTypeId = 0;
                                        inputType = Utils.API_TYPE_PROJECT_ID;
                                    }
                                    else if (utmSourceTypeId.includes(':PJN')) {
                                        let sp = utmSourceTypeId.split(':PJN');
                                        let projectName = sp[0];
                                        utmSourceId = sp[1];
                                        utmSourceTypeText = projectName;
                                        utmSourceTypeId = 0;
                                        inputType = Utils.API_TYPE_PROJECT_NAME;
                                    }
                                    else if (utmSourceTypeId.includes(':PJS')) {
                                        let sp = utmSourceTypeId.split(':PJS');
                                        let projectSlug = sp[0];
                                        utmSourceId = sp[1];
                                        utmSourceTypeText = projectSlug;
                                        utmSourceTypeId = 0;
                                        inputType = Utils.API_TYPE_PROJECT_SLUG;
                                    }
                                    else if (utmSourceTypeId.includes(':PMS')) {
                                        let sp = utmSourceTypeId.split(':PMS');
                                        let promotionSlug = sp[0];
                                        utmSourceId = sp[1];
                                        utmSourceTypeText = promotionSlug;
                                        utmSourceTypeId = 0;
                                        inputType = Utils.API_TYPE_PROMOTION_SLUG;
                                    }
                                    else if (utmSourceTypeId.includes(':LINEOA')) {
                                        let sp = utmSourceTypeId.split(':LINEOA');
                                        let lineOAUrl = sp[0];
                                        utmSourceId = sp[1];
                                        utmSourceTypeText = lineOAUrl;
                                        utmSourceTypeId = 0;
                                        inputType = Utils.API_TYPE_LINE_OAID;
                                    }
                                    else {
                                        let sourceTypeRow = await Utils.getUtmSourceTypeById(utmSourceTypeId);
                                        utmSourceId = sourceTypeRow.utmSourceId;
                                        utmSourceTypeText = sourceTypeRow.name;
                                    }

                                    sourceTypeIds.push({
                                        utmSourceId: utmSourceId,
                                        utmSourceTypeId: utmSourceTypeId,
                                        utmSourceTypeText: utmSourceTypeText,
                                        inputType: inputType
                                    });
                                }
                            }
                        }

                        if (sourceTypeIds.length !== selectSourceTypeIds.length) {
                            setLoading(false);
                            setButtonText(btnTextDefault);
                            generateTypeUTMValidate.message = 'กรุณาเลือก UTM [' + generateGroupCampaign[n].name + '][ตัวที่ ' + (idx + 1) + '] ให้ครบถ้วน';
                            break;
                        }
                        else {
                            utmParams[n][idx] = sourceTypeIds;
                        }
                    }
                }
            }
            setLoading(false);
            setButtonText(btnTextDefault);
        }

        let url = refUrl.current.value;
        let campaignSlug = refCampaignSlug?.current?.value;
        let adssetSlug = refAdssetSlug?.current?.value;

        if(!campaignTemplateId) {
            toast.error("กรุณาระบุ Campaign Template");
        }
        else if(!isCustomUrl && !langId) {
            toast.error("กรุณาระบุ Language");
        }
        else if(generateTypeUTM && !url) {
            toast.error("กรุณาระบุ URL");
            refUrl.current.focus();
        }
        else if(!campaignId) {
            toast.error("กรุณาระบุ Campaign ID");
        }
        else if(!isCustomUrl && !specialFilterId) {
            toast.error("กรุณาระบุ Filter Type");
        }
        else if(!isCustomUrl && specialFilterId && specialFilterId.id === Utils.ADS_NAMING_SPECIAL_FILTER_BG_ZONE && !projectTypeId) {
            toast.error("กรุณาระบุ Zone Project");
        }
        else if(!isCustomUrl && specialFilterId && specialFilterId.id === Utils.ADS_NAMING_SPECIAL_FILTER_BG_ZONE && !zoneStatusId) {
            toast.error("กรุณาระบุ Zone Status");
        }
        else if(!isCustomUrl && specialFilterId && specialFilterId.id === Utils.ADS_NAMING_SPECIAL_FILTER_BG_ZONE && !bgZoneId) {
            toast.error("กรุณาระบุ BG Zone");
        }
        else if(!isCustomUrl && specialFilterId && specialFilterId.id === Utils.ADS_NAMING_SPECIAL_FILTER_COMBINE_ZONE && !zoneStatusId) {
            toast.error("กรุณาระบุ Zone Status");
        }
        else if(!isCustomUrl && specialFilterId && specialFilterId.id === Utils.ADS_NAMING_SPECIAL_FILTER_COMBINE_ZONE && !combineZoneId) {
            toast.error("กรุณาระบุ Combine Zone");
        }
        else if(!isCustomUrl && specialFilterId && specialFilterId.id === Utils.ADS_NAMING_SPECIAL_FILTER_EVENT_REMINDER && !eventDate) {
            toast.error("กรุณาระบุ Event Date");
        }
        else if(!isCustomUrl && specialFilterId && specialFilterId.id === Utils.ADS_NAMING_SPECIAL_FILTER_EVENT_REMINDER && !eventReminderId) {
            toast.error("กรุณาระบุ Event Reminder");
        }
        else if(!isCustomUrl && specialFilterId && specialFilterId.id === Utils.ADS_NAMING_SPECIAL_FILTER_STATIC_PAGE && !staticPageId) {
            toast.error("กรุณาระบุ Static Page");
        }
        else if(isCustomUrl && generateTypeCampaign && campaignSlug === '') {
            toast.error("กรุณาระบุ Campaign Special Slug");
        }
        else if(isCustomUrl && generateTypeAdsSet && adssetSlug === '') {
            toast.error("กรุณาระบุ Ads Set Special Slug");
        }
        else if(generateTypeCampaignValidate.message) {
            toast.error(generateTypeCampaignValidate.message);
        }
        else if(generateTypeAdsSetValidate.message) {
            toast.error(generateTypeAdsSetValidate.message);
        }
        else if(generateTypeUTMValidate.message) {
            toast.error(generateTypeUTMValidate.message);
        }
        else {

            confirmAlert({
                title: 'แจ้งเตือน',
                message: 'ต้องการบันทึกข้อมูล ?',
                buttons: [
                    {
                        label: 'ตกลง',
                        onClick: async() => {
                            setLoading(true);
                            setButtonText(btnTextLoading);

                            let bulkBody = [];
                            if(generateGroupCampaign && generateGroupCampaign.length > 0) {
                                for (let n = 0; n < generateGroupCampaign.length; n++) {
                                    if (generateGroupCampaign[n].masterAdssetItems && generateGroupCampaign[n].masterAdssetItems.length > 0) {
                                        for (let idx = 0; idx < generateGroupCampaign[n].masterAdssetItems.length; idx++) {
                                            let body = {
                                                campaignTemplateId: campaignTemplateId ? campaignTemplateId.id : null,
                                                typeId: Utils.GENERATE_TYPE_SPECIAL,
                                                lang: langId ? langId.id : null,
                                                projectTypeId: projectTypeId ? projectTypeId.id : null,
                                                campaignId: campaignId ? campaignId.campaign_id : null,
                                                specialFilterId: specialFilterId ? specialFilterId.id:null,
                                                zoneStatus: zoneStatusId ? zoneStatusId.id:null,
                                                eventDate: eventDate ? new Date(eventDate) : null,
                                                webPage: null,
                                                adsPlatformId: generateGroupCampaign[n].adsPlatformId,
                                                generateGroupCampaignId: generateGroupCampaign[n].id,
                                                isCustomUrl: isCustomUrl ? 1:null,
                                                agencyId: roles.agencyId,
                                                slug: campaignItemSlug,
                                                url: url,
                                                createdBy: userId,
                                                createdAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
                                                updatedAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss')
                                            };

                                            if(generateTypeCampaign) {
                                                body.generateTypeCampaign = 1;
                                                body.paramsCampaign = campaignParam[n].params;
                                                body.campaignSourceTypeIds = campaignParam[n].data;
                                            }
                                            if(generateTypeAdsSet) {
                                                body.generateTypeAdsset = 1;
                                                body.paramsAdsset = adssetParams[n][idx].params;
                                                body.adssetSourceTypeIds = adssetParams[n][idx].data;

                                                let selectedAdsNamingSetNameType = document.getElementsByName('selectedAdsNamingSetNameType['+n+'][' + idx + ']');
                                                let adsNamingSetNameTypeId = null;
                                                if (selectedAdsNamingSetNameType.length > 0) {
                                                    adsNamingSetNameTypeId = selectedAdsNamingSetNameType[0].value;
                                                }
                                                body.adsNamingSetNameTypeId = adsNamingSetNameTypeId;
                                            }
                                            if(generateTypeUTM) {
                                                //Main URL
                                                url = url.toString().trim();

                                                let hashtagText = '';
                                                let selectedHashtag = document.getElementsByName('selectedHashtag['+n+'][' + idx + ']');
                                                if(selectedHashtag.length > 0) {
                                                    hashtagText = selectedHashtag[0].value;
                                                }

                                                //Create Params
                                                let params = await Utils.generateParams(null, null, idx, n);
                                                params = params + (hashtagText ? '#' + hashtagText:'');
                                                let urlParam = url + '?' + params;

                                                //Create Short URL (Rebrandly)
                                                let rebrandlyUrl = null;
                                                if(urlParam && rebrandlyChecked[n])  {
                                                    const resShortUrl = await Utils.getRebrandlyShortURL(rebrandly, urlParam);
                                                    rebrandlyUrl = resShortUrl.shortUrl;
                                                    //rebrandlyUrl = 'rebrandlyUrl-XXX';
                                                }

                                                //Create Short URL (Short.IO)
                                                let shortioUrl = null;
                                                if(urlParam && shortioChecked[n])  {
                                                    const resShortUrl = await Utils.createShortioShortURL(urlParam);
                                                    shortioUrl = resShortUrl.path;
                                                    //shortioUrl = 'shortioUrl-XXX';
                                                }

                                                body.generateTypeUTM = 1;
                                                body.paramsUTM = params;
                                                body.utmTemplateId = utmTemplateId ? utmTemplateId.id : null;
                                                body.utmGroupId = null;
                                                body.utmGroupItemId = null;
                                                body.hashtag = hashtagText ? hashtagText : null;
                                                body.shortUrl = rebrandlyUrl;
                                                body.shortioUrl = shortioUrl;
                                                body.utmSourceTypeIds = utmParams[n][idx];
                                            }

                                            bulkBody.push(body);
                                        }
                                    }
                                }
                            }

                            fetch(Config.url.API_URL +'/api/generate/createBulks', {
                                method: 'POST',
                                body: JSON.stringify(bulkBody),
                                headers: {
                                    'Content-Type':'application/json',
                                    'x-access-token': roles.accessToken
                                }
                            }).then(response => {
                                if(response.ok) {
                                    return response.json();
                                }
                                else {
                                    return response.json().then(err => Promise.reject(err));
                                }
                            }).then(result => {
                                if(result) {
                                    toast.success("บันทึกข้อมูลเรียบร้อย");
                                    setTimeout(function () {
                                        navigate('/generateSpecial', {replace: true});
                                    }, 1500);
                                }
                                else {
                                    setLoading(false);
                                }
                            }).catch(err => {
                                toast.error(err.message);
                            });
                        }
                    },
                    {
                        label: 'ยกเลิก',
                        onClick: () => {
                            setLoading(false);
                            setButtonText(btnTextDefault);
                        }
                    }
                ]
            });
        }
    };

    const onChangeCustomUrl = async (flag) => {
        setIsCustomUrl(flag);
        setSlugDisabled(!flag);
        setCampaignTemplateId(null);
        setCampaignId(null);
        setPlatformId(null);
        setLanguageId(null);
        setSpecialFilterId(null);
        setProjectTypeId(null);
        setZoneStatusId(null);
        setBgZoneId(null);
        setCombineZoneId(null);
        setStaticPageId(null);
        setEventDate('');
        refUrl.current.value = '';

        setGenerateGroupId(null);

        setCampaignItemSlug('');
        setAdssetItemSlug('');

        setDisableTemplate(true);
        const resTemplate = await Utils.getCampaignTemplate(Utils.GENERATE_TYPE_SPECIAL);
        if(flag) {
            setCampaignTemplate(resTemplate.filter(e => e.isCustomUrl === 1));
        }
        else {
            setCampaignTemplate(resTemplate.filter(e => e.isCustomUrl === null));
        }
        setDisableTemplate(false);
    };

    const onChangeFilterTypeId = async (obj) => {
        setSpecialFilterId(obj);
        setProjectTypeId(null);
        setZoneStatusId(null);
        if(obj?.id === Utils.ADS_NAMING_SPECIAL_FILTER_STATIC_PAGE && langId) {
            setStaticPagePlaceholder('กำลังโหลด...');
            const resEv = await Utils.getStaticPage({langId: langId.id});
            setStaticPagePlaceholder('เลือก..');
            if(resEv && resEv.data && resEv.data) {
                setStaticPage(resEv.data);
            }
            else {
                toast.error('ไม่พบข้อมูล Static Page');
            }
        }
    };

    const onChangeProjectTypeId = async (obj) => {
        setProjectTypeId(obj);
        setBgZone('');
        setZoneStatusId(null);
        setBgZoneId(null);
        setCombineZoneId(null);
        if(obj && obj.id && zoneStatusId) {
            setBgZonePlaceholder('กำลังโหลด...');
            const resBGZone = await Utils.getBGZone({langId: langId.id, projectTypeId: obj.id, zoneStatusId: zoneStatusId.id});
            setBgZonePlaceholder('เลือก..');
            if(resBGZone && resBGZone.data && resBGZone.data.zones) {
                setBgZone(resBGZone.data.zones);
            }
            else {
                toast.error('ไม่พบข้อมูล BG Zone');
            }
        }
    };

    const onChangeZoneStatusId = async (obj) => {
        setZoneStatusId(obj);
        setBgZone('');
        setCombineZone('');
        setBgZoneId(null);
        setCombineZoneId(null);
        if(obj && obj.id && projectTypeId && langId && specialFilterId.id === Utils.ADS_NAMING_SPECIAL_FILTER_BG_ZONE) {
            setBgZonePlaceholder('กำลังโหลด...');
            const resBGZone = await Utils.getBGZone({langId: langId.id, projectTypeId: projectTypeId.id, zoneStatusId: obj.id});
            setBgZonePlaceholder('เลือก..');
            if(resBGZone && resBGZone.data && resBGZone.data.zones) {
                setBgZone(resBGZone.data.zones);
            }
            else {
                toast.error('ไม่พบข้อมูล BG Zone');
            }
        }
        else if(obj && obj.id && specialFilterId.id === Utils.ADS_NAMING_SPECIAL_FILTER_COMBINE_ZONE) {
            setCombineZonePlaceholder('กำลังโหลด...');
            const resCombineZone = await Utils.getCombineZone({langId: langId.id, zoneStatusId: obj.id});
            setCombineZonePlaceholder('เลือก..');
            if(resCombineZone && resCombineZone.data && resCombineZone.data.zones) {
                setCombineZone(resCombineZone.data.zones);
            }
            else {
                toast.error('ไม่พบข้อมูล Combine Zone');
            }
        }
    };

    const onChangeEventDate = async (value) => {
        setEventDate(value);
        setEventReminderPlaceholder('กำลังโหลด...');
        const resEv = await Utils.getEventReminder({langId: langId.id, eventDate: value});
        setEventReminderPlaceholder('เลือก..');
        if(resEv && resEv.data && resEv.data) {
            setEventReminder(resEv.data);
        }
        else {
            toast.error('ไม่พบข้อมูล Event Reminder');
        }
    };

    const onChangeBGZoneId = async (obj) => {
        refUrl.current.value = obj.zone_url ?? '';
        if(generateGroupId) {
            if(generateTypeCampaign) {
                refCampaignSlug.current.value = obj.zone_slug ?? '';
            }
            if(generateTypeAdsSet) {
                refAdssetSlug.current.value = obj.zone_slug ?? '';
            }
        }
        if(obj && obj.zone_slug) {
            setCampaignItemSlug(obj.zone_slug);
            setAdssetItemSlug(obj.zone_slug);
        }
        setBgZoneId(obj);
    };

    const onChangeCombineZoneId = async (obj) => {
        refUrl.current.value = obj.zone_url ?? '';
        if(generateGroupId) {
            if (generateTypeCampaign) {
                refCampaignSlug.current.value = obj.zone_slug ?? '';
            }
            if (generateTypeAdsSet) {
                refAdssetSlug.current.value = obj.zone_slug ?? '';
            }
        }
        if(obj && obj.zone_slug) {
            setCampaignItemSlug(obj.zone_slug);
            setAdssetItemSlug(obj.zone_slug);
        }
        setCombineZoneId(obj);
    };

    const onChangeEventReminderId = async (obj) => {
        refUrl.current.value = obj.event_url ?? '';
        if(generateGroupId) {
            if (generateTypeCampaign) {
                refCampaignSlug.current.value = obj.event_slug ?? '';
            }
            if (generateTypeAdsSet) {
                refAdssetSlug.current.value = obj.event_slug ?? '';
            }
        }
        if(obj && obj.event_slug) {
            setCampaignItemSlug(obj.event_slug);
            setAdssetItemSlug(obj.event_slug);
        }
        setEventReminderId(obj);
    };

    const onChangeStaticPageId = async (obj) => {
        refUrl.current.value = obj.web_url ?? '';
        if(generateGroupId) {
            if (generateTypeCampaign) {
                refCampaignSlug.current.value = obj.web_page ?? '';
            }
            if (generateTypeAdsSet) {
                refAdssetSlug.current.value = obj.web_page ?? '';
            }
        }
        if(obj && obj.web_page) {
            setCampaignItemSlug(obj.web_page);
            setAdssetItemSlug(obj.web_page);
        }
        setStaticPageId(obj);
    };

    const onChangeLanguageId = (obj) => {
        setLanguageId(obj);
        setSpecialFilterId(null);
        setProjectTypeId(null);
        setZoneStatusId(null);
        setBgZoneId(null);
        setCombineZoneId(null);
        setStaticPageId(null);
        setEventDate('');

        if(generateGroupId) {
            if(generateTypeCampaign) {
                refCampaignSlug.current.value = '';
            }
            if(generateTypeAdsSet) {
                refAdssetSlug.current.value = '';
            }
        }
    };

    const onChangeCampaignId = (obj) => {
        setCampaignId(obj);
    };

    //-- Template
    const onChangeCampaignTemplateId =  async (obj) => {
        setCampaignTemplateId(null);
        setCampaignId(null);
        setPlatformId(null);
        setLanguageId(null);
        setSpecialFilterId(null);
        setProjectTypeId(null);
        setZoneStatusId(null);
        setBgZoneId(null);
        setCombineZoneId(null);
        setStaticPageId(null);
        setEventDate('');
        setGenerateGroupId(null);
        refUrl.current.value = '';

        //Set data from template
        if(obj && obj.id) {
            setCampaignTemplateId(obj);
            let templateRow = campaignTemplate.filter(e => e.id === obj.id)[0];
            setLanguageId(lang.filter(e => e.id === templateRow.lang)[0]);
            setCampaignId(campaign.filter(e => e.campaign_id === templateRow.campaignId)[0]);
            setPlatformId(platform.filter(e => e.id === templateRow.adsPlatformId)[0]);
            refUrl.current.value = templateRow.url ?? '';

            if(isCustomUrl) {
                let str = Utils.getSpecialSlug(templateRow.url);
                refUrl.current.value = str.originalUrl;
                setCampaignItemSlug(str.slug);
                setAdssetItemSlug(str.slug);
            }
            else {
                setCampaignItemSlug(templateRow.slug);
                setAdssetItemSlug(templateRow.slug);
                
                if(specialFilter) {
                    setSpecialFilterId(specialFilter.filter(e => e.id === templateRow.specialFilterId)[0]);
                }
                if(projectType) {
                    setProjectTypeId(projectType.filter(e => e.id === templateRow.projectTypeId)[0]);
                }
                if(zoneStatus) {
                    setZoneStatusId(zoneStatus.filter(e => e.id === templateRow.zoneStatus)[0]);
                }

                if(templateRow.specialFilterId === Utils.ADS_NAMING_SPECIAL_FILTER_BG_ZONE) {
                    setBgZonePlaceholder('กำลังโหลด...');
                    const resBGZone = await Utils.getBGZone({
                        langId: templateRow.lang,
                        projectTypeId: templateRow.projectTypeId,
                        zoneStatusId: templateRow.zoneStatus
                    });
                    setBgZonePlaceholder('เลือก..');
                    if(resBGZone && resBGZone.data && resBGZone.data.zones) {
                        setBgZone(resBGZone.data.zones);
                        setBgZoneId(resBGZone.data.zones.filter(e => e.zone_slug === templateRow.slug)[0]);
                    }
                    else {
                        toast.error('ไม่พบข้อมูล BG Zone');
                    }
                }
                else if(templateRow.specialFilterId === Utils.ADS_NAMING_SPECIAL_FILTER_COMBINE_ZONE) {
                    setCombineZonePlaceholder('กำลังโหลด...');
                    const resCombineZone = await Utils.getCombineZone({
                        langId: templateRow.lang,
                        zoneStatusId: templateRow.zoneStatus
                    });
                    setCombineZonePlaceholder('เลือก..');
                    if(resCombineZone && resCombineZone.data && resCombineZone.data.zones) {
                        setCombineZone(resCombineZone.data.zones);
                        setCombineZoneId(resCombineZone.data.zones.filter(e => e.zone_slug === templateRow.slug)[0]);
                    }
                    else {
                        toast.error('ไม่พบข้อมูล Combine Zone');
                    }
                }
                else if(templateRow.specialFilterId === Utils.ADS_NAMING_SPECIAL_FILTER_EVENT_REMINDER) {
                    if(templateRow.eventDate) {
                        setEventDate(new Date(templateRow.eventDate));
                        setEventReminderPlaceholder('กำลังโหลด...');
                        const resEv = await Utils.getEventReminder({
                            langId: templateRow.lang,
                            eventDate: templateRow.eventDate
                        });
                        setEventReminderPlaceholder('เลือก..');
                        if(resEv && resEv.data) {
                            setEventReminderId(resEv.data.filter(e => e.event_slug === templateRow.slug)[0]);
                            setEventReminder(resEv.data);
                        }
                        else {
                            toast.error('ไม่พบข้อมูล Event Reminder');
                        }
                    }
                }
                else if(templateRow.specialFilterId === Utils.ADS_NAMING_SPECIAL_FILTER_STATIC_PAGE) {
                    setStaticPage('');
                    setStaticPageId(null);

                    setStaticPagePlaceholder('กำลังโหลด...');
                    const resEv = await Utils.getStaticPage({langId: templateRow.lang});
                    setStaticPagePlaceholder('เลือก..');
                    if(resEv && resEv.data) {
                        setStaticPageId(resEv.data.filter(e => e.web_page === templateRow.slug)[0]);
                        setStaticPage(resEv.data);
                    }
                    else {
                        toast.error('ไม่พบข้อมูล Static Page');
                    }
                }
            }
        }
    };


    //region -- Campaign
    let [campaignAdsNaming, setCampaignAdsNaming] = React.useState(null);
    let [campaignExample, setCampaignExample] = React.useState('');
    let [campaignKolPage, setCampaignKolPage] = React.useState('');
    let [campaignPreview, setCampaignPreview] = React.useState([]);
    let [campaignItemSlug, setCampaignItemSlug] = React.useState('');
    let [campaignItemFreeForm, setCampaignItemFreeForm] = React.useState('');

    let [generateGroup, setGenerateGroup] = React.useState(null);
    let [generateGroupId, setGenerateGroupId] = React.useState(null);
    let [generateGroupCampaign, setGenerateGroupCampaign] = React.useState(null);
    let [generateLoading, setGenerateGroupLoading] = React.useState(false);

    const campaignDetail = async () => {
        const resGenerateGroup = await Utils.getGenerateGroup();
        if(resGenerateGroup) {
            setGenerateGroup(resGenerateGroup.filter(e => e.typeId === Utils.GENERATE_TYPE_SPECIAL));
        }

        const resAdsNaming = await Utils.getAdsNamingCampaign();
        if(resAdsNaming.length > 0) {
            let ex = [];
            for(let rs of resAdsNaming) {
                if(rs.inputType !== Utils.ADSNAMING_TYPE_SLUG_PROMOTION && rs.inputType !== Utils.ADSNAMING_TYPE_SLUG_PROJECT) {
                    ex.push('{' + rs.name + '}');
                    if(rs.name === 'Objective') {
                        ex.push('{Platform}');
                    }
                }
            }
            setCampaignExample(ex[1] + '|' + ex.join('_') + '_[ST]|{Campaign ID}');

            let newKolPageId = [];
            for(let rs of resAdsNaming) {
                if(rs.inputType === Utils.ADSNAMING_TYPE_KOL_PAGE) {
                    const resKolPage = await getKol();
                    if(resKolPage) {
                        let campaignKolPageIds = [];
                        for(let row of resKolPage) {
                            let id = row.id;
                            campaignKolPageIds.push({
                                id: id + ':KOL' + rs.id,
                                name:  row.name
                            });
                        }
                        rs.source = campaignKolPageIds;

                        newKolPageId.push({
                            id: rs.id,
                            data: campaignKolPageIds
                        });
                    }
                }
            }
            setCampaignKolPage(newKolPageId);
        }
        setCampaignAdsNaming(resAdsNaming);
    };
    const onCampaignPreview = async (n) => {
        let previewArr = [];
        const param = await getCampaignParams(n);
        previewArr[n] = param.params;
        setCampaignPreview(previewArr);
    };
    async function getCampaignParams(n) {
        let textParams = [];
        let sourceIds = [];
        let kolIds = [];

        //STEP 1 : Find Selected
        let sourceTypeIds = [];
        let sourceTypeAllIds = [];
        let selectSourceTypeIds = document.getElementsByName('sourceTypeIdsCampaign['+n+'][]');
        if(selectSourceTypeIds) {
            for(let st of selectSourceTypeIds) {
                let sourceTypeId = st.value;
                if(sourceTypeId) {
                    //STEP 1.1 : Find special selector
                    if(sourceTypeId.includes(':KOL')) {
                        let sp = sourceTypeId.split(':KOL');
                        let kolId = sp[0];
                        let adsNamingId = sp[1];
                        if(kolId) {
                            campaignKolPage.find(rs => {
                                if(parseInt(rs.id) === parseInt(adsNamingId)) {
                                    let data = rs.data.find(e => {
                                        let id = e.id;
                                        if(id.toString().includes(kolId + ':')) {
                                            return e;
                                        }
                                    });
                                    if(data) {
                                        kolIds.push({
                                            adsNamingSourceId: parseInt(kolId),
                                            adsNamingId: parseInt(adsNamingId),
                                            name: data ? data.name : null,
                                            inputType: Utils.ADSNAMING_TYPE_KOL_PAGE
                                        });
                                    }
                                }
                            });
                        }
                    }
                    else {
                        sourceTypeIds.push(sourceTypeId);
                    }
                    sourceTypeAllIds.push(sourceTypeId);
                }
            }
        }

        //STEP 2 : Get selector type
        if(sourceTypeIds.length > 0) {
            let result = await Utils.getSourceTypeForParam(sourceTypeIds);
            if(result) {
                for(let row of result) {
                    sourceIds.push({
                        adsNamingSourceId: row.id,
                        adsNamingId: row.adsNamingId,
                        name: row.name,
                        inputType: null
                    });
                }
            }
        }

        //STEP 4 : Get for params
        if(campaignAdsNaming.length > 0) {
            campaignAdsNaming.map(async (row, index) => {
                let value = '';
                let inputText = "sourceTypeTextCampaign["+n+"][" + row.id + "]";
                let textSourceTypeIds = document.getElementsByName(inputText);

                if(textSourceTypeIds && textSourceTypeIds[0]) {
                    value = textSourceTypeIds[0].value;
                    if(value.length > 0) {
                        textParams.push({
                            adsNamingSourceId: null,
                            adsNamingId: row.id,
                            text: value,
                            inputType: row.inputType
                        });
                    }
                }
                else {
                    if(row.inputType === Utils.ADSNAMING_TYPE_KOL_PAGE) {
                        if(kolIds) {
                            let find = kolIds.find(kol => {
                                if(kol.adsNamingId === row.id) {
                                    return kol;
                                }
                            });
                            if(find && find.name) {
                                textParams.push({
                                    adsNamingSourceId: find.adsNamingSourceId,
                                    adsNamingId: row.id,
                                    text: find.name,
                                    inputType: row.inputType
                                });
                            }
                        }
                    }
                    else {
                        let find = sourceIds.find(rs => {
                            if(parseInt(rs.adsNamingId) === parseInt(row.id)) {
                                return rs;
                            }
                        });
                        if(find && find.name) {
                            textParams.push({
                                adsNamingSourceId: find.adsNamingSourceId,
                                adsNamingId: row.id,
                                text: find.name,
                                inputType: null
                            });
                        }

                        if(row.name === 'Objective') {
                            let platformName = '';
                            if(platform && platformId && platformId.id) {
                                platformName = platform.filter(e => e.id === platformId.id)[0].name;
                                textParams.push({
                                    adsNamingSourceId: null,
                                    adsNamingId: null,
                                    text: platformName,
                                    inputType: null
                                });
                            }
                        }
                    }
                }
            });
        }

        let params = textParams ? (textParams[1] && textParams[1].text) + '|' + textParams.map(x => x.text).join('_') + '_[ST]|' + (campaignId ? campaignId.campaign_id:'') : null;

        return {
            params: params,
            data: textParams,
            success: sourceTypeAllIds.length === selectSourceTypeIds.length
        };
    }
    const onChangeGenerateGroupId = async (obj) => {
        setGenerateGroupLoading(true);
        setGenerateGroupId(null);
        if(obj && obj.id) {
            setGenerateGroupId(obj);
            const generateGroupList = await Utils.getGenerateGroupCampaign(obj.id);
            if(generateGroupList) {

                setGenerateTypeAdsSet(null);
                setGenerateTypeUTM(null);
                for (let row of generateGroupList) {
                    let sourceTypeSelectedIds = [];
                    if (row.items) {
                        for (let rs of row.items) {
                            let adsNamingSourceId = rs.adsNamingSourceId;
                            if (adsNamingSourceId) {
                                if (rs.inputType === Utils.ADSNAMING_TYPE_KOL_PAGE) {
                                    sourceTypeSelectedIds.push(adsNamingSourceId + ':KOL' + rs.adsNamingId);
                                }
                                else {
                                    sourceTypeSelectedIds.push(adsNamingSourceId);
                                }
                            }
                            else if(rs.inputType === Utils.ADSNAMING_TYPE_FREEFORM) {
                                setCampaignItemFreeForm(row.items.filter(e => e.inputType === Utils.ADSNAMING_TYPE_FREEFORM)[0].text);
                            }
                        }
                    }
                    row.campaignItemSelected = sourceTypeSelectedIds;

                    if(row.master.length > 0) {
                        let checkAssetItem = row.master.filter(e => e.masterAdssetItems);
                        if(checkAssetItem.length > 0) {
                            setGenerateTypeAdsSet(true);
                            row.masterAdssetItems = checkAssetItem;
                        }
                        let checkUtmItem = row.master.filter(e => e.masterUtmItems);
                        if(checkUtmItem.length > 0) {
                            setGenerateTypeUTM(true);
                            row.masterUtmItems = checkUtmItem;
                            for(let row of checkUtmItem) {
                                if(row.utmTemplateId && utmTemplate) {
                                    await onChangeTemplateId(utmTemplate.filter(e => e.id === row.utmTemplateId)[0]);
                                }
                            }
                        }
                    }
                }
                setGenerateGroupCampaign(generateGroupList.filter(e => e.master.length > 0));
                setGenerateGroupLoading(false);
            }
        }
    };
    //endregion

    //region -- Ads Set
    let [adsNamingSetNameType, setAdsNamingSetNameType] = React.useState(null);
    let [adssetAdsNaming, setAdssetAdsNaming] = React.useState(null);
    let [adssetExample, setAdssetExample] = React.useState('');
    let [adssetPreview, setAdssetPreview] = React.useState([]);
    let [adssetItemSlug, setAdssetItemSlug] = React.useState('');

    const adssetDetail = async () => {
        const resSetNameType = await Utils.getAdsNamingSetNameType();
        setAdsNamingSetNameType(resSetNameType);

        const resAdssetName = await Utils.getAdsNamingSetName();
        if(resAdssetName.length > 0) {
            let ex = [];
            let ex2 = [];
            let newAdsNaming = [];
            if(resAdssetName) {
                newAdsNaming = resAdssetName.filter(row => row.inputType !== Utils.ADSNAMING_TYPE_SLUG_PROJECT && row.inputType !== Utils.ADSNAMING_TYPE_SLUG_PROMOTION);
                let xLen = newAdsNaming.length;
                if(xLen > 1) {
                    for(let i=0;i<2;i++) {
                        ex.push('{' + newAdsNaming[i].name + '}');
                    }
                }
                if(xLen > 2) {
                    for(let j=2;j<xLen;j++) {
                        ex2.push('{' + newAdsNaming[j].name + '}');
                    }
                }
            }
            setAdssetAdsNaming(newAdsNaming);
            setAdssetExample(ex.join('_') + '|' + ex2.join('_') + '_{Platform}|{Type}_[ST]');
        }
    };
    const onAdssetPreview = async (n) => {
        let previewArr = [[], []];
        if(generateGroupCampaign[n] && generateGroupCampaign[n].masterAdssetItems.length > 0) {
            for(let idx=0;idx<generateGroupCampaign[n].masterAdssetItems.length;idx++) {
                const param = await getAdssetParams(n, idx);
                previewArr[n][idx] = param.params;
            }
        }
        setAdssetPreview(previewArr);
    };
    async function getAdssetParams(n, idx) {
        let textParams = [];
        let textBoxParams = [];
        let sourceIds = [];

        //STEP 1 : Find Selected
        let sourceTypeIds = [];
        let sourceTypeAllIds = [];
        let selectSourceTypeIds = document.getElementsByName('sourceTypeIdsAdsset['+n+'][' + idx + '][]');
        if(selectSourceTypeIds) {
            for(let st of selectSourceTypeIds) {
                let sourceTypeId = st.value;
                if(sourceTypeId) {
                    //STEP 1.1 : Find special selector
                    sourceTypeIds.push(sourceTypeId);
                    sourceTypeAllIds.push(sourceTypeId);
                }
            }
        }

        //STEP 2 : Get selector type
        if(sourceTypeIds.length > 0) {
            let result = await Utils.getSourceTypeForParam(sourceTypeIds);
            if(result) {
                for(let row of result) {
                    sourceIds.push({
                        adsNamingSourceId: row.id,
                        adsNamingId: row.adsNamingId,
                        name: row.name,
                        inputType: null
                    });
                }
            }
        }

        //STEP 4 : Get for params
        if(adssetAdsNaming.length > 0) {
            adssetAdsNaming.map(async (row, index) => {
                let value = '';
                let inputText = "sourceTypeTextAdsset["+n+"][" + idx + "][" + row.id + "]";
                let textSourceTypeIds = document.getElementsByName(inputText);

                if(textSourceTypeIds && textSourceTypeIds[0]) {
                    value = textSourceTypeIds[0].value;
                    textParams.push({
                        adsNamingSourceId: null,
                        adsNamingId: row.id,
                        text: value,
                        inputType: row.inputType
                    });
                    textBoxParams = textParams;
                }
                else {
                    let find = sourceIds.find(rs => {
                        if(parseInt(rs.adsNamingId) === parseInt(row.id)) {
                            return rs;
                        }
                    });
                    if(find && find.name) {
                        textParams.push({
                            adsNamingSourceId: find.adsNamingSourceId,
                            adsNamingId: row.id,
                            text: find.name,
                            inputType: null
                        });
                    }
                }
            });
        }

        //Fixed BG
        let bg = textParams.length > 0 ? textParams[0].text:'';

        //Fixed Slug Special
        let slugSpecial = textBoxParams.length > 1 ? textParams[1].text:'';

        //After that
        let textParamsNew = [];
        let showOtherParam = '';
        let xLength = textBoxParams.length;

        if(textBoxParams.length > 2) {
            for(let i=2;i<xLength;i++) {
                if(textBoxParams[i].text.length > 0) {
                    textParamsNew.push({
                        adsNamingSourceId: textBoxParams[i].adsNamingSourceId,
                        adsNamingId: textBoxParams[i].id,
                        text: textBoxParams[i].text,
                        inputType: null
                    });
                }
            }
            showOtherParam = textParamsNew.map(x => x.text).join('_');
        }

        let platformName = '';
        if(platform && platformId && platformId.id) {
            platformName = '_' + platform.filter(e => e.id === platformId.id)[0].name;
        }

        let adsNamingSetNameTypeText = '';
        let selectedSetNameType = document.getElementsByName('selectedAdsNamingSetNameType['+n+'][' + idx + ']');
        if(selectedSetNameType && selectedSetNameType.length > 0) {
            let selectedSetNameTypeValue = selectedSetNameType[0].value;
            let adsNamingSetNameTypeRow = adsNamingSetNameType.filter(e => e.id === parseInt(selectedSetNameTypeValue))[0];
            adsNamingSetNameTypeText = adsNamingSetNameTypeRow.name
        }

        let params = bg + '_' + slugSpecial + '|' + showOtherParam + platformName + '|' + adsNamingSetNameTypeText + '_[ST]';

        return {
            params: params,
            data: textParams,
            success: sourceTypeAllIds.length === selectSourceTypeIds.length
        };
    }
    //endregion

    //region -- UTM
    let [utmTemplate, setUtmTemplate] = React.useState(null);
    let [utmTemplateId, setUtmTemplateId] = React.useState(null);
    let [hashtagList, setHashtagList] = React.useState(null);
    let [rebrandly, setRebrandly] = React.useState(null);
    let [shortio, setShortIO] = React.useState(null);
    let [rebrandlyChecked, setRebrandlyChecked] = React.useState(false);
    let [shortioChecked, setShortioChecked] = React.useState(false);
    let [utmPreviewing, setUTMPreviewing] = React.useState(false);
    let [utmPreview, setUTMPreview] = React.useState([]);
    let [utm, setUtm] = React.useState('');
    let [showUTMListing, setShowUtmListing] = React.useState(false);
    let [templateSource, setTemplateSource] = React.useState('');
    let [contentId, setContentId] = React.useState('');
    let [ownerId, setOwnerId] = React.useState('');
    let [userAgency, setUserAgency] = React.useState(null);

    const utmDetail = async () => {
        const resTemplate = await Utils.getTemplate({agencyId: roles.agencyId});
        setUtmTemplate(resTemplate);
        const resRebrandly = await Utils.getRebrandly();
        setRebrandly(resRebrandly);
        const resShortIO = await Utils.getShortIO();
        setShortIO(resShortIO);
        const resHashtag = await Utils.getHashtag();
        setHashtagList(resHashtag);
        const resAgency = await Utils.getAgency({agencyId: roles.agencyId});
        if(resAgency) {
            setUserAgency(resAgency[0]);
        }
    };
    const onUTMPreview = async (n) => {
        setUTMPreviewing(true);
        let previewArr = [[], []];
        if(generateGroupCampaign[n] && generateGroupCampaign[n].masterUtmItems.length > 0) {
            for(let idx=0;idx<generateGroupCampaign[n].masterUtmItems.length;idx++) {
                let params = await Utils.generateParams({langId: langId}, null, idx, n);

                let url = refUrl ? refUrl.current.value : '';

                let hashtagText = '';
                let selectedHashtag = document.getElementsByName('selectedHashtag[' + n + '][' + idx + ']');
                if(selectedHashtag.length > 0) {
                    hashtagText = selectedHashtag[0].value;
                }

                previewArr[n][idx] = (url ? url.toString().trim() + '?':'') + params + (hashtagText ? '#' + hashtagText:'');
            }
        }

        setUTMPreviewing(false);
        setUTMPreview(previewArr);
    };
    const onChangeTemplateId = async (obj) => {
        setShowUtmListing(false);
        setUtmTemplateId(obj);
        setUTMPreview([]);

        if(obj && obj.id) {
            const resSource = await Utils.getTemplateSourceById(obj.id);
            setTemplateSource(resSource);
            const resUtm = await Utils.getUtmByIds(resSource);
            setUtm(resUtm);
            setShowUtmListing(true);

            if(resSource.length > 0) {
                //example
                for(let utm of resUtm) {
                    if(resSource) {
                        let ex = [];
                        for(let rs of resSource) {
                            if(utm.id === rs.utmId) {
                                ex.push('{' + rs.source.name + '}');
                            }
                        }
                        utm.example = ex.join('_');
                    }
                }

                resSource.map( async (rs, idx) => {
                    if(rs.source.inputType === Utils.API_TYPE_CONTENT_ID) {
                        const resContentId = await Utils.getContentId({agencyId: roles.agencyId});
                        let newContentId = [];
                        if(resContentId) {
                            for(let row of resContentId) {
                                newContentId.push({
                                    id: row.id,
                                    xid: row.id + ':CID' + rs.source.id,
                                    name:  Utils.contentIdGenerater(row)
                                });
                            }
                        }
                        setContentId(newContentId);
                    }
                    else if(rs.source.inputType === Utils.API_TYPE_OWNER_ID) {
                        const resOwnerId = await Utils.getOwner({agencyId: roles.agencyId});
                        let newOwnerId = [];
                        if(resOwnerId) {
                            for(let row of resOwnerId) {
                                newOwnerId.push({
                                    id: row.id,
                                    xid: row.id + ':OID' + rs.source.id,
                                    name: row.code.charAt(0) + ' : ' + row.name
                                });
                            }
                        }
                        setOwnerId(newOwnerId);
                    }
                });
            }
        }
    };
    const onShortioChecked = (n, isChecked) => {
        shortioChecked[n] = isChecked;
        setShortioChecked(shortioChecked);
    };
    const ontRebrandlyChecked = (n, isChecked) => {
        rebrandlyChecked[n] = isChecked;
        setRebrandlyChecked(rebrandlyChecked);
    };
    //endregion

    return (

        <main>
            <div className="row table-toolbar mb-2">
                <div className="col-6 align-self-center">
                    <div className="h6 d-inline"><span className="text-success">&#8226;</span> Generate Special</div>
                    <span className="ms-1">/</span> <span className="text-muted">Create</span>
                </div>
                <div className="col-6 text-end align-self-center toolbars">
                </div>
            </div>
            <div className="rounded bg-white p-4 shadow">
                <div className="row">
                    <div className="col-12 col-md-5">
                        <form className="row g-3">
                            <div className="col-12">
                                <label htmlFor="langId" className="form-label">Special Type</label>
                                <div className="row">
                                    <div className="col-sm-6">
                                        <div className="form-check">
                                            <input className="form-check-input" type="radio" name="urlType"
                                                   id="urlType1" checked={!isCustomUrl} onChange={e => onChangeCustomUrl(false)} />
                                            <label className="form-check-label" htmlFor="urlType1">
                                                AP Special
                                            </label>
                                        </div>
                                    </div>
                                    <div className="col-sm-6">
                                        <div className="form-check">
                                            <input className="form-check-input" type="radio" name="urlType"
                                                   id="urlType2" checked={isCustomUrl} onChange={e => onChangeCustomUrl(true)} />
                                            <label className="form-check-label" htmlFor="urlType2">
                                                Custom URL
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12">
                                <label htmlFor="langId" className="form-label">Campaign Template <span className="text-danger">*</span></label>
                                <Select
                                    isClearable={true}
                                    isDisabled={disableTemplate}
                                    classNamePrefix="form-select-search"
                                    options={campaignTemplate}
                                    onChange={(event) => onChangeCampaignTemplateId(event)}
                                    value={campaignTemplateId}
                                    getOptionValue={(option) => `${option.id}`}
                                    getOptionLabel={(option) => `${option.name}`}
                                />
                            </div>
                            <div className="col-12">
                                <label htmlFor="url" className="form-label">URL <span className={"text-danger" + (generateTypeUTM ? '':' d-none')}>*</span></label>
                                <textarea className="form-control" id="url" ref={refUrl} rows={5} disabled={campaignTemplateId} onBlur={
                                    e => {
                                        let str = Utils.getSpecialSlug(e.target.value);
                                        refUrl.current.value = str.originalUrl;
                                        setCampaignItemSlug(str.slug);
                                        setAdssetItemSlug(str.slug);
                                    }
                                }></textarea>
                            </div>
                            <div className="col-12">
                                <label htmlFor="campaignId" className="form-label">Campaign ID <span className="text-danger">*</span></label>
                                <Select
                                    isDisabled={campaignTemplateId}
                                    classNamePrefix="form-select-search"
                                    placeholder={campaignPlaceholder}
                                    options={campaign}
                                    onChange={(event) => onChangeCampaignId(event)}
                                    value={campaignId}
                                    getOptionValue={(option) => `${option.campaign_id}`}
                                    getOptionLabel={(option) => `${option.campaign_id} : ${option.campaign_name}`}
                                />
                            </div>
                            <div className="col-12">
                                <div className={"row g-3 border rounded bg-light p-2 mt-0" + (isCustomUrl ? ' d-none':'')}>
                                    <div className={"col-12 mt-1" + (isCustomUrl ? ' d-none':'')}>
                                        <label htmlFor="langId" className="form-label">Language <span className="text-danger">*</span></label>
                                        <Select
                                            isDisabled={campaignTemplateId}
                                            classNamePrefix="form-select-search"
                                            options={lang}
                                            onChange={(event) => onChangeLanguageId(event)}
                                            value={langId}
                                            getOptionValue={(option) => `${option.id}`}
                                            getOptionLabel={(option) => `${option.name}`}
                                        />
                                    </div>
                                    <div className={"col-12" + (isCustomUrl ? ' d-none':'')}>
                                        <label htmlFor="specialFilterId" className="form-label">Filter Type <span className="text-danger">*</span></label>
                                        <Select
                                            isDisabled={campaignTemplateId}
                                            classNamePrefix="form-select-search"
                                            options={specialFilter}
                                            onChange={(event) => onChangeFilterTypeId(event)}
                                            value={specialFilterId}
                                            getOptionValue={(option) => `${option.id}`}
                                            getOptionLabel={(option) => `${option.name}`}
                                        />
                                    </div>
                                    <div className={"col-12" + (isCustomUrl || specialFilterId?.id !== Utils.ADS_NAMING_SPECIAL_FILTER_BG_ZONE ? ' d-none':'')}>
                                        <label htmlFor="zoneProject" className="form-label">Zone Project <span className="text-danger">*</span></label>
                                        <Select
                                            isDisabled={campaignTemplateId}
                                            classNamePrefix="form-select-search"
                                            options={projectType}
                                            onChange={(event) => onChangeProjectTypeId(event)}
                                            value={projectTypeId}
                                            getOptionValue={(option) => `${option.id}`}
                                            getOptionLabel={(option) => `${option.name}`}
                                        />
                                    </div>
                                    <div className={"col-12" + (isCustomUrl || (specialFilterId?.id !== Utils.ADS_NAMING_SPECIAL_FILTER_BG_ZONE && specialFilterId?.id !== Utils.ADS_NAMING_SPECIAL_FILTER_COMBINE_ZONE) ? ' d-none':'')}>
                                        <label htmlFor="zoneStatus" className="form-label">Zone Status <span className="text-danger">*</span></label>
                                        <Select
                                            isDisabled={campaignTemplateId}
                                            classNamePrefix="form-select-search"
                                            options={zoneStatus}
                                            onChange={(event) => onChangeZoneStatusId(event)}
                                            value={zoneStatusId}
                                            getOptionValue={(option) => `${option.id}`}
                                            getOptionLabel={(option) => `${option.name}`}
                                        />
                                    </div>
                                    <div className={"col-12" + (isCustomUrl || specialFilterId?.id !== Utils.ADS_NAMING_SPECIAL_FILTER_BG_ZONE ? ' d-none':'')}>
                                        <label htmlFor="bgZone" className="form-label">BG Zone <span className="text-danger">*</span></label>
                                        <Select
                                            isDisabled={campaignTemplateId || (!campaignTemplateId && (!langId || !projectTypeId || !zoneStatusId))}
                                            placeholder={bgZonePlaceholder}
                                            classNamePrefix="form-select-search"
                                            options={bgZone}
                                            onChange={(event) => onChangeBGZoneId(event)}
                                            value={bgZoneId}
                                            getOptionValue={(option) => `${option.zone_slug}`}
                                            getOptionLabel={(option) => `${option.zone_name} - ${option.zone_slug}`}
                                        />
                                    </div>
                                    <div className={"col-12" + (isCustomUrl || specialFilterId?.id !== Utils.ADS_NAMING_SPECIAL_FILTER_COMBINE_ZONE ? ' d-none':'')}>
                                        <label htmlFor="combineZone" className="form-label">Combine Zone <span className="text-danger">*</span></label>
                                        <Select
                                            isDisabled={campaignTemplateId || (!campaignTemplateId && (!langId || !zoneStatusId))}
                                            placeholder={combineZonePlaceholder}
                                            classNamePrefix="form-select-search"
                                            options={combineZone}
                                            onChange={(event) => onChangeCombineZoneId(event)}
                                            value={combineZoneId}
                                            getOptionValue={(option) => `${option.zone_slug}`}
                                            getOptionLabel={(option) => `${option.zone_name} - ${option.zone_slug}`}
                                        />
                                    </div>
                                    <div className={"col-12" + (isCustomUrl || specialFilterId?.id !== Utils.ADS_NAMING_SPECIAL_FILTER_EVENT_REMINDER ? ' d-none':'')}>
                                        <label htmlFor="eventDate" className="form-label">Event Date <span className="text-danger">*</span></label>
                                        <DatePicker
                                            selected={eventDate}
                                            disabled={campaignTemplateId}
                                            onChange={(date) => onChangeEventDate(date)}
                                            dateFormat="yyyy-MM-dd"
                                            wrapperClassName="w-100"
                                            className="form-control" />
                                    </div>
                                    <div className={"col-12" + (isCustomUrl || specialFilterId?.id !== Utils.ADS_NAMING_SPECIAL_FILTER_EVENT_REMINDER ? ' d-none':'')}>
                                        <label htmlFor="eventReminder" className="form-label">Event Reminder <span className="text-danger">*</span></label>
                                        <Select
                                            isDisabled={campaignTemplateId || !eventDate}
                                            placeholder={eventReminderPlaceholder}
                                            classNamePrefix="form-select-search"
                                            options={eventReminder}
                                            onChange={(event) => onChangeEventReminderId(event)}
                                            value={eventReminderId}
                                            getOptionValue={(option) => `${option.event_slug}`}
                                            getOptionLabel={(option) => `${option.event_title} - ${option.event_slug}`}
                                        />
                                    </div>
                                    <div className={"col-12" + (isCustomUrl || specialFilterId?.id !== Utils.ADS_NAMING_SPECIAL_FILTER_STATIC_PAGE ? ' d-none':'')}>
                                        <label htmlFor="eventReminder" className="form-label">Static Page <span className="text-danger">*</span></label>
                                        <Select
                                            isDisabled={campaignTemplateId || (!campaignTemplateId && (!langId || !eventDate))}
                                            placeholder={staticPagePlaceholder}
                                            classNamePrefix="form-select-search"
                                            options={staticPage}
                                            onChange={(event) => onChangeStaticPageId(event)}
                                            value={staticPageId}
                                            getOptionValue={(option) => `${option.web_page}`}
                                            getOptionLabel={(option) => `${option.web_page}`}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 mt-4">
                                <button type="button" className="btn btn-primary" onClick={onCreate} disabled={isLoading || !generateGroupCampaign || generateGroupCampaign.length === 0}><span
                                    className={isLoading ? 'spinner-grow spinner-grow-sm' : 'd-none'}></span> {buttonText}</button>
                                <NavLink className="btn btn-sm btn-light ms-2" to='/generateSpecial'><span><Icon.ArrowLeft/> กลับไป</span></NavLink>
                                <Toaster position="bottom-right" />
                            </div>
                        </form>
                    </div>
                    <div className="col-12 col-md-7 mt-3 mt-md-0">
                        <form className="row g-3">
                            <div className={"col-12" + (generateTypeCampaign ? '':' d-none')}>
                                <label htmlFor="generateGroupId" className="form-label">Group <span className="text-danger">*</span></label>
                                <Select
                                    classNamePrefix="form-select-search"
                                    options={generateGroup}
                                    onChange={(event) => onChangeGenerateGroupId(event)}
                                    value={generateGroupId}
                                    getOptionValue={(option) => `${option.id}`}
                                    getOptionLabel={(option) => `${option.name}`}
                                />
                            </div>
                        </form>

                        {
                            !generateLoading && generateGroupId && generateGroupCampaign && (generateTypeCampaign || generateTypeAdsSet || generateTypeUTM) ?
                                <>
                                    <ul className="nav nav-tabs mt-3" id="myTabGroup" role="tablist">
                                        {
                                            generateGroupCampaign ?
                                                generateGroupCampaign.map((record, n) => {
                                                    return (
                                                        <li className="nav-item ms-1" role="presentation">
                                                            <button className={"nav-link" + (n === 0 ? ' active':'')} id={"tabGroup-tab" + n } data-bs-toggle="tab"
                                                                    data-bs-target={"#tabGroup" + n} type="button" role="tab" aria-controls={"tabCampaign" + n}
                                                                    aria-selected="true">{record.name}
                                                            </button>
                                                        </li>
                                                    )
                                                }) : ''
                                        }
                                    </ul>

                                    {
                                        generateGroupCampaign ?
                                            generateGroupCampaign.map((record, n) => {
                                                let campaignItemSelected = record.campaignItemSelected;
                                                return (
                                                    <div className="tab-content" id="myTabContent">
                                                        <div className={"tab-pane p-2 fade" + (n === 0 ? ' show active':'')} id={"tabGroup" + n} role="tabpanel" aria-labelledby={"tabGroup-tab" + n}>
                                                            <ul className="nav nav-tabs mt-3" id="myTab" role="tablist">
                                                                {
                                                                    generateTypeCampaign ?
                                                                        <li className="nav-item ms-1" role="presentation">
                                                                            <button className={"nav-link campaign-color active"} id={"tabCampaign-tab" + n} data-bs-toggle="tab" data-bs-target={"#tabCampaign" + n} type="button" role="tab" aria-controls={"tabCampaign" + n} aria-selected="true">Campaign
                                                                            </button>
                                                                        </li> : ''
                                                                }
                                                                {
                                                                    generateTypeAdsSet ?
                                                                        <li className="nav-item ms-1" role="presentation">
                                                                            <button className={"nav-link adsset-color" + (!generateTypeCampaign ? ' active':'')} id={"tabAdsSet-tab" + n} data-bs-toggle="tab" data-bs-target={"#tabAdsSet" + n} type="button" role="tab" aria-controls="profile" aria-selected="false">Ads Set
                                                                            </button>
                                                                        </li> : ''
                                                                }
                                                                {
                                                                    generateTypeUTM ?
                                                                        <li className="nav-item ms-1" role="presentation">
                                                                            <button className={"nav-link utm-color" + (!generateTypeCampaign && !generateTypeAdsSet ? ' active':'')} id={"tabUTM-tab" + n} data-bs-toggle="tab" data-bs-target={"#tabUTM" + n} type="button" role="tab" aria-controls={"tabUTM" + n} aria-selected="false">UTM
                                                                            </button>
                                                                        </li> : ''
                                                                }
                                                            </ul>

                                                            <div className="tab-content" id={"myTabContent" + n}>
                                                                {
                                                                    generateTypeCampaign ?
                                                                        <div className="tab-pane p-2 campaign-bg fade show active" id={"tabCampaign" + n} role="tabpanel" aria-labelledby={"tabCampaign-tab" + n}>
                                                                            <div className="row g-3 p-2">
                                                                                <div className="col-12">
                                                                                    <div className="d-block mb-1 small">{campaignExample}</div>
                                                                                    <label htmlFor="preview" className="form-label"><button type="button" className="btn btn-sm btn-light" onClick={e => onCampaignPreview(n)}>Preview</button></label>
                                                                                </div>
                                                                                {
                                                                                    campaignAdsNaming === null || campaignAdsNaming.length <= 0 ? (<p>ไม่พบข้อมูล Ads Naming</p>) :
                                                                                        campaignAdsNaming.map((row, index) => {
                                                                                            let inputText = "sourceTypeTextCampaign["+n+"]["+row.id+"]";
                                                                                            let formId = '';
                                                                                            let source = row.source;
                                                                                            let inputType = row.inputType;
                                                                                            let selected = null;
                                                                                            let inputSelect = "sourceTypeIdsCampaign["+n+"][]";

                                                                                            if(inputType === Utils.ADSNAMING_TYPE_SLUG_SPECIAL) {
                                                                                                formId = 'slug-special-campaign';
                                                                                                return (
                                                                                                    <div key={index} className="col-12">
                                                                                                        <div className="d-block fw-bold">{row.name} <span className="text-danger">*</span>
                                                                                                        </div>
                                                                                                        <div className=" css-b62m3t-container"><input className="form-control" type="text" id={formId} name={inputText} ref={refCampaignSlug} defaultValue={campaignItemSlug} disabled={slugDisabled} /></div>
                                                                                                    </div>
                                                                                                );
                                                                                            }
                                                                                            else if(inputType === Utils.ADSNAMING_TYPE_SLUG_PROMOTION) {
                                                                                                // -- empty
                                                                                            }
                                                                                            else if(inputType === Utils.ADSNAMING_TYPE_SLUG_PROJECT) {
                                                                                                // -- empty
                                                                                            }
                                                                                            else if(inputType === Utils.ADSNAMING_TYPE_FREEFORM) {
                                                                                                formId = 'freeform';
                                                                                                return (
                                                                                                    <div key={index} className="col-12">
                                                                                                        <div className="d-block fw-bold">{row.name}</div>
                                                                                                        <div className=" css-b62m3t-container"><input className="form-control bg-white" type="text" id={formId} name={inputText} defaultValue={campaignItemFreeForm} onKeyUp={async e => {
                                                                                                            if(e && e.target.value) {
                                                                                                                e.target.value = Utils.utmSlug(e.target.value);
                                                                                                            }
                                                                                                        }} /></div>
                                                                                                    </div>
                                                                                                );
                                                                                            }
                                                                                            else if(inputType === Utils.ADSNAMING_TYPE_KOL_PAGE) {

                                                                                                if(campaignItemSelected) {
                                                                                                    for (let cs of source) {
                                                                                                        let id = cs.id;
                                                                                                        let sp = id.split(':KOL');
                                                                                                        let kol = parseInt(sp[0]) + ':KOL' + parseInt(row.id);
                                                                                                        if (campaignItemSelected.includes(kol)) {
                                                                                                            selected = {id: id, name: cs.name};
                                                                                                            break;
                                                                                                        }
                                                                                                        else {
                                                                                                            selected = source.filter(e => e.name === 'none')[0];
                                                                                                            break;
                                                                                                        }
                                                                                                    }
                                                                                                }
                                                                                                else {
                                                                                                    selected = source.filter(e => e.name === 'none')[0];
                                                                                                }

                                                                                                return (
                                                                                                    <div key={index} className="col-12">
                                                                                                        <div className="d-block fw-bold">{row.name} <span className="text-danger">*</span></div>
                                                                                                        <div className=" css-b62m3t-container">
                                                                                                            <Select
                                                                                                                isClearable={false}
                                                                                                                name={inputSelect}
                                                                                                                classNamePrefix="form-select-search"
                                                                                                                options={source}
                                                                                                                defaultValue={selected}
                                                                                                                getOptionValue={(option) => `${option.id}`}
                                                                                                                getOptionLabel={(option) => `${option.name}`}
                                                                                                            />
                                                                                                        </div>
                                                                                                    </div>
                                                                                                );
                                                                                            }
                                                                                            else {

                                                                                                if(campaignItemSelected) {
                                                                                                    for(let cs of source) {
                                                                                                        let id = cs.id;
                                                                                                        if(campaignItemSelected.includes(id)) {
                                                                                                            selected = {id: id, name: cs.name};
                                                                                                            break;
                                                                                                        }
                                                                                                    }
                                                                                                }

                                                                                                if(row.name !== 'BG' && row.name !== 'AgencyMaster') {
                                                                                                    return (
                                                                                                        <div key={index} className="col-12">
                                                                                                            <div className="d-block fw-bold">{row.name} <span className="text-danger">*</span></div>
                                                                                                            <Select
                                                                                                                isClearable={false}
                                                                                                                name={inputSelect}
                                                                                                                classNamePrefix="form-select-search"
                                                                                                                options={source}
                                                                                                                defaultValue={selected}
                                                                                                                getOptionValue={(option) => `${option.id}`}
                                                                                                                getOptionLabel={(option) => `${option.name}`}
                                                                                                            />
                                                                                                        </div>
                                                                                                    );
                                                                                                }
                                                                                                else {

                                                                                                    if(row.name === 'Agency' || row.name === 'AgencyMaster') {
                                                                                                        if(roles.agencyId && agency) {
                                                                                                            let ag = agency.filter(e => e.id === roles.agencyId)[0];
                                                                                                            selected = source.filter(e => e.name === ag.slug);
                                                                                                        }
                                                                                                    }

                                                                                                    return (
                                                                                                        <div key={index} className="col-12">
                                                                                                            <div className="d-block fw-bold">{row.name} <span className="text-danger">*</span></div>
                                                                                                            <Select
                                                                                                                isClearable={false}
                                                                                                                name={inputSelect}
                                                                                                                classNamePrefix="form-select-search"
                                                                                                                options={source}
                                                                                                                defaultValue={selected}
                                                                                                                getOptionValue={(option) => `${option.id}`}
                                                                                                                getOptionLabel={(option) => `${option.name}`}
                                                                                                            />
                                                                                                        </div>
                                                                                                    );
                                                                                                }
                                                                                            }
                                                                                        })
                                                                                }

                                                                                <div className="col-12 mt-3">
                                                                                    <div className="noselect-url w100 rounded">{campaignPreview ? campaignPreview[n] : ''}</div>
                                                                                    <p className="mt-2 mb-0">ตัวอักษร : {campaignPreview && campaignPreview[n] ? campaignPreview[n].length : ''}</p>
                                                                                </div>
                                                                            </div>
                                                                        </div> : ''
                                                                }
                                                                {
                                                                    generateTypeAdsSet ?
                                                                        <div className={"tab-pane p-2 adsset-bg fade" + (!generateTypeCampaign ? ' show active':'')} id={"tabAdsSet" + n} role="tabpanel" aria-labelledby={"tabAdsSet-tab" + n}>
                                                                            <div className="row g-3 p-2">
                                                                                <div className="col-12">
                                                                                    <div className="d-block mb-1 small">{adssetExample}</div>
                                                                                    <button type="button" className="btn btn-sm btn-light mb-1" onClick={e => onAdssetPreview(n)}>Preview</button>
                                                                                </div>

                                                                                <div className="col-12">
                                                                                    {
                                                                                        record.masterAdssetItems && record.masterAdssetItems.length > 0 ?
                                                                                            record.masterAdssetItems.map((rs, idx) => {
                                                                                                let items = rs.masterAdssetItems;
                                                                                                let adsNamingSetNameTypeSelected = adsNamingSetNameType.filter(e => e.id === rs.adsNamingSetNameTypeId)[0];
                                                                                                let adssetItemFreeForm = items.filter(e => e.inputType === Utils.ADSNAMING_TYPE_FREEFORM)[0]?.text;
                                                                                                return (
                                                                                                    <>
                                                                                                        <div key={idx} className={"row g-3 p-2 pt-0 adsset-bg2" + (idx > 0 ? ' mt-4':' mt-1')}>
                                                                                                            {
                                                                                                                adssetAdsNaming === null || adssetAdsNaming.length <= 0 ? (<p>ไม่พบข้อมูล Ads Naming</p>) :
                                                                                                                    adssetAdsNaming.map((row, index) => {
                                                                                                                        let inputText = "sourceTypeTextAdsset["+n+"]["+idx+"]["+row.id+"]";
                                                                                                                        let formId = '';
                                                                                                                        let source = row.source;
                                                                                                                        let inputType = row.inputType;
                                                                                                                        let selected = null;

                                                                                                                        if(inputType === Utils.ADSNAMING_TYPE_SLUG_SPECIAL) {
                                                                                                                            formId = 'slug-special-campaign';
                                                                                                                            return (
                                                                                                                                <div key={index} className="col-12">
                                                                                                                                    <div className="d-block fw-bold">{row.name} <span className="text-danger">*</span>
                                                                                                                                    </div>
                                                                                                                                    <div className=" css-b62m3t-container"><input className="form-control" type="text" id={formId} name={inputText} ref={refAdssetSlug} defaultValue={adssetItemSlug} disabled={slugDisabled} /></div>
                                                                                                                                </div>
                                                                                                                            );
                                                                                                                        }
                                                                                                                        else if(inputType === Utils.ADSNAMING_TYPE_SLUG_PROMOTION) {
                                                                                                                            // -- empty
                                                                                                                        }
                                                                                                                        else if(inputType === Utils.ADSNAMING_TYPE_SLUG_PROJECT) {
                                                                                                                            // -- empty
                                                                                                                        }
                                                                                                                        else if(inputType === Utils.ADSNAMING_TYPE_FREEFORM) {
                                                                                                                            formId = 'freeform';
                                                                                                                            return (
                                                                                                                                <div key={index} className="col-12">
                                                                                                                                    <div className="d-block fw-bold">{row.name}</div>
                                                                                                                                    <div className=" css-b62m3t-container"><input className="form-control bg-white" type="text" id={formId} name={inputText} defaultValue={adssetItemFreeForm} onKeyUp={async e => {
                                                                                                                                        if(e && e.target.value) {
                                                                                                                                            e.target.value = Utils.utmSlug(e.target.value);
                                                                                                                                        }
                                                                                                                                    }} /></div>
                                                                                                                                </div>
                                                                                                                            );
                                                                                                                        }
                                                                                                                        else {

                                                                                                                            for(let it of items) {
                                                                                                                                let adsNamingSourceId = it.adsNamingSourceId;
                                                                                                                                let filter = source.filter(e => e.id === adsNamingSourceId);
                                                                                                                                if(filter && filter.length > 0) {
                                                                                                                                    selected = {id: filter[0].id, name: filter[0].name};
                                                                                                                                }
                                                                                                                            }

                                                                                                                            let inputSelect = "sourceTypeIdsAdsset["+n+"]["+idx+"][]";
                                                                                                                            if(row.name !== 'BG' && row.name !== 'AgencyMaster') {
                                                                                                                                return (
                                                                                                                                    <div key={index} className="col-12">
                                                                                                                                        <div className="d-block fw-bold">{row.name} <span className="text-danger">*</span></div>
                                                                                                                                        <Select
                                                                                                                                            isClearable={false}
                                                                                                                                            name={inputSelect}
                                                                                                                                            classNamePrefix="form-select-search"
                                                                                                                                            options={source}
                                                                                                                                            defaultValue={selected}
                                                                                                                                            getOptionValue={(option) => `${option.id}`}
                                                                                                                                            getOptionLabel={(option) => `${option.name}`}
                                                                                                                                        />
                                                                                                                                    </div>
                                                                                                                                );
                                                                                                                            }
                                                                                                                            else {

                                                                                                                                return (
                                                                                                                                    <div key={index} className="col-12">
                                                                                                                                        <div className="d-block fw-bold">{row.name} <span className="text-danger">*</span></div>
                                                                                                                                        <Select
                                                                                                                                            isClearable={false}
                                                                                                                                            name={inputSelect}
                                                                                                                                            classNamePrefix="form-select-search"
                                                                                                                                            options={source}
                                                                                                                                            defaultValue={selected}
                                                                                                                                            getOptionValue={(option) => `${option.id}`}
                                                                                                                                            getOptionLabel={(option) => `${option.name}`}
                                                                                                                                        />
                                                                                                                                    </div>
                                                                                                                                );
                                                                                                                            }
                                                                                                                        }
                                                                                                                    })
                                                                                                            }

                                                                                                            <div className="col-12">
                                                                                                                <label htmlFor="adsNamingSetNameType" className="form-label">Type <span className="text-danger">*</span></label>
                                                                                                                <Select
                                                                                                                    isClearable={false}
                                                                                                                    name={"selectedAdsNamingSetNameType["+n+"]["+idx+"]"}
                                                                                                                    classNamePrefix="form-select-search"
                                                                                                                    options={adsNamingSetNameType}
                                                                                                                    defaultValue={adsNamingSetNameTypeSelected}
                                                                                                                    getOptionValue={(option) => `${option.id}`}
                                                                                                                    getOptionLabel={(option) => `${option.name}`}
                                                                                                                />
                                                                                                            </div>

                                                                                                            <div className="col-12 mt-3">
                                                                                                                <label htmlFor="preview" className="form-label">Preview</label>
                                                                                                                <div className="noselect-url w100 rounded">{adssetPreview[n] && adssetPreview[n][idx] ? adssetPreview[n][idx] : ''}</div>
                                                                                                                <p className="mt-2 mb-0">ตัวอักษร : {adssetPreview && adssetPreview[n] && adssetPreview[n][idx] ? adssetPreview[n][idx].length:''}</p>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    </>
                                                                                                )
                                                                                            }) : ''
                                                                                    }
                                                                                </div>
                                                                            </div>

                                                                        </div> : ''
                                                                }
                                                                {
                                                                    generateTypeUTM ?
                                                                        <div className={"tab-pane p-2 utm-bg fade" + (!generateTypeCampaign && !generateTypeAdsSet ? ' show active':'')} id={"tabUTM" + n} role="tabpanel" aria-labelledby={"tabUTM-tab" + n}>
                                                                            <div className="row g-3 p-2">

                                                                                <div className="col-12">
                                                                                    <button type="button" className="btn btn-sm btn-light" onClick={e => onUTMPreview(n)}>Preview</button>
                                                                                </div>

                                                                                <div className="col-12 mt-4">
                                                                                    {
                                                                                        record.masterUtmItems !== null && record.masterUtmItems.length > 0 ?
                                                                                            record.masterUtmItems.map((rs, idx) => {
                                                                                                let items = rs.masterUtmItems;
                                                                                                let hastagSelected = null;
                                                                                                if(hashtagList && rs.hashtag) {
                                                                                                    hastagSelected = hashtagList.filter(e => e.id === rs.hashtag)[0];
                                                                                                }
                                                                                                return (
                                                                                                    <>
                                                                                                        <div key={idx} className={"row g-3 p-2 pt-0 utm-bg2" + (idx > 0 ? ' mt-4' : ' mt-0')}>
                                                                                                            <div className="col-12">
                                                                                                                <label htmlFor="template" className="form-label">Template <span className="text-danger">*</span></label>
                                                                                                                <Select
                                                                                                                    isClearable={false}
                                                                                                                    isDisabled={true}
                                                                                                                    classNamePrefix="form-select-search"
                                                                                                                    options={utmTemplate}
                                                                                                                    value={utmTemplateId}
                                                                                                                    getOptionValue={(option) => `${option.id}`}
                                                                                                                    getOptionLabel={(option) => `${option.name}`}
                                                                                                                />
                                                                                                            </div>

                                                                                                            <div className={"col-12 " + (utmTemplateId === null ? 'd-none' : '')}>
                                                                                                                {
                                                                                                                    utm.length <= 0 ? '' :
                                                                                                                        utm.map((row, index) => {
                                                                                                                            return (
                                                                                                                                showUTMListing ? <div key={index} className={"border rounded bg-yellow-light p-2" + (index+1 !== utm.length ? ' mb-3' : '')}>
                                                                                                                                    <div className="d-block fw-bold">{(row.utmPrefix === 1 ? 'utm_':'') + row.name.toLowerCase()} <span className="text-danger">*</span></div>
                                                                                                                                    <div className="d-block mb-1 small">{row.example}</div>
                                                                                                                                    {
                                                                                                                                        templateSource.length <= 0 ? (<p>ไม่พบข้อมูล source</p>) :
                                                                                                                                            templateSource.map((rs, index2) => {
                                                                                                                                                if(rs.source && rs.utmId === row.id) {
                                                                                                                                                    let isClearable = true;
                                                                                                                                                    let rsSource = rs.source.sourceType;
                                                                                                                                                    let inputType = rs.source.inputType;
                                                                                                                                                    let selected = null;
                                                                                                                                                    let canBeSelect = false;

                                                                                                                                                    if(inputType === Utils.API_TYPE_CONTENT_ID) {
                                                                                                                                                        if(contentId) {
                                                                                                                                                            rsSource = contentId;
                                                                                                                                                            for(let cs of rsSource) {
                                                                                                                                                                cs.id = cs.xid;
                                                                                                                                                            }
                                                                                                                                                            canBeSelect = true;
                                                                                                                                                        }
                                                                                                                                                    }
                                                                                                                                                    else if(inputType === Utils.API_TYPE_OWNER_ID) {
                                                                                                                                                        if(ownerId) {
                                                                                                                                                            rsSource = ownerId;
                                                                                                                                                            for(let cs of rsSource) {
                                                                                                                                                                cs.id = cs.xid;
                                                                                                                                                            }
                                                                                                                                                            canBeSelect = true;
                                                                                                                                                        }
                                                                                                                                                    }
                                                                                                                                                    else if(inputType === Utils.API_TYPE_CAMPAIGN_ID) {

                                                                                                                                                        if(campaignId) {
                                                                                                                                                            selected = {
                                                                                                                                                                id: campaignId.campaign_id + ':CP' + rs.source.id,
                                                                                                                                                                name: campaignId.campaign_id
                                                                                                                                                            };
                                                                                                                                                            rsSource = selected;
                                                                                                                                                        }
                                                                                                                                                    }
                                                                                                                                                    else if(inputType === Utils.API_TYPE_CAMPAIGN_NAME) {

                                                                                                                                                        if(campaignId) {
                                                                                                                                                            selected = {
                                                                                                                                                                id: campaignId.campaign_name + ':CN' + rs.source.id,
                                                                                                                                                                name: campaignId.campaign_name
                                                                                                                                                            };
                                                                                                                                                            rsSource = selected;
                                                                                                                                                        }
                                                                                                                                                    }

                                                                                                                                                    else if(inputType === Utils.API_TYPE_PROJECT_ID) {
                                                                                                                                                        //--
                                                                                                                                                    }
                                                                                                                                                    else if(inputType === Utils.API_TYPE_PROJECT_NAME) {
                                                                                                                                                        //--
                                                                                                                                                    }
                                                                                                                                                    else if(inputType === Utils.API_TYPE_PROJECT_SLUG) {
                                                                                                                                                        //--
                                                                                                                                                    }
                                                                                                                                                    else if(inputType === Utils.API_TYPE_PROMOTION_SLUG) {
                                                                                                                                                        //--
                                                                                                                                                    }
                                                                                                                                                    else if(inputType === Utils.API_TYPE_LINE_OAID) {
                                                                                                                                                        //--
                                                                                                                                                    }
                                                                                                                                                    else {
                                                                                                                                                        for(let it of items) {
                                                                                                                                                            let utmSourceTypeId = parseInt(it.utmSourceTypeId);
                                                                                                                                                            let filter = rsSource.filter(e => e.id === utmSourceTypeId);
                                                                                                                                                            if(filter && filter.length > 0) {
                                                                                                                                                                selected = {id: filter[0].id, name: filter[0].name};
                                                                                                                                                            }
                                                                                                                                                        }
                                                                                                                                                        canBeSelect = true;
                                                                                                                                                    }

                                                                                                                                                    let inputSelect = "sourceTypeIds["+n+"]["+idx+"][]";
                                                                                                                                                    return (
                                                                                                                                                        <div key={index2} className="ms-2 mt-3">
                                                                                                                                                            <div className="row mt-2">
                                                                                                                                                                <div className="col-12 col-sm-4 text-end small">
                                                                                                                                                                    {rs.source.name} :
                                                                                                                                                                </div>
                                                                                                                                                                <div className="col-12 col-sm-8">
                                                                                                                                            <span className="text-muted small fw-light">{
                                                                                                                                                inputType === Utils.API_TYPE_PROJECT_NAME ?
                                                                                                                                                    '{lang}-{project_type_slug}-{project_slug}' : ''
                                                                                                                                            }</span>
                                                                                                                                                                    <Select
                                                                                                                                                                        isClearable={false}
                                                                                                                                                                        isSearchable={isClearable}
                                                                                                                                                                        name={inputSelect}
                                                                                                                                                                        classNamePrefix="form-select-search"
                                                                                                                                                                        placeholder={rsSource.length ? 'Select...':'...'}
                                                                                                                                                                        defaultValue={selected}
                                                                                                                                                                        options={canBeSelect ? rsSource : [rsSource]}
                                                                                                                                                                        getOptionValue={(option) => `${option.id}`}
                                                                                                                                                                        getOptionLabel={(option) => `${option.name}`}
                                                                                                                                                                    />
                                                                                                                                                                    {userAgency?.isEncrypt === 1 && rs.source.isEncrypt ? <span className="badge bg-secondary small">encrypt</span>:''}
                                                                                                                                                                </div>
                                                                                                                                                            </div>
                                                                                                                                                        </div>
                                                                                                                                                    );
                                                                                                                                                }
                                                                                                                                            })
                                                                                                                                    }
                                                                                                                                </div> : ''
                                                                                                                            );
                                                                                                                        })
                                                                                                                }
                                                                                                            </div>

                                                                                                            <div className="col-12">
                                                                                                                <label htmlFor="typeIed" className="form-label">Hashtag (#)</label>
                                                                                                                <Select
                                                                                                                    isClearable={false}
                                                                                                                    name={"selectedHashtag["+n+"]["+idx+"]"}
                                                                                                                    classNamePrefix="form-select-search"
                                                                                                                    options={hashtagList}
                                                                                                                    defaultValue={hastagSelected}
                                                                                                                    getOptionValue={(option) => `${option.name}`}
                                                                                                                    getOptionLabel={(option) => `${option.name}`}
                                                                                                                />
                                                                                                            </div>

                                                                                                            <div className="col-12">
                                                                                                                <label htmlFor="preview" className="form-label">Preview <span
                                                                                                                    className={utmPreviewing ? 'spinner-grow spinner-grow-sm' : 'd-none'}></span></label>
                                                                                                                <div className="noselect-url w100 rounded">{utmPreview && utmPreview[n] ? utmPreview[n][idx] : ''}</div>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    </>
                                                                                                )
                                                                                            }) : ''
                                                                                    }
                                                                                </div>

                                                                                <div className={"col-12" + (roles.isShortLink(Utils.MENU_UTM_GENERATE) && rebrandly && rebrandly.status===1 && rebrandly.apiKey && rebrandly.endpoint ? '':' d-none')}>
                                                                                    <label htmlFor="rebrandlyUrlx" className="form-label">Create Short URL (Rebrandly)</label>
                                                                                    <div className="form-check form-switch">
                                                                                        <input className="form-check-input" type="checkbox" name="rebrandlyUrlChecked" onChange={e => ontRebrandlyChecked(n, e.target.checked)} />
                                                                                        <label className="form-check-label" htmlFor="rebrandlyUrl"></label>
                                                                                    </div>
                                                                                </div>

                                                                                <div className={"col-12" + (roles.isShortLink(Utils.MENU_UTM_GENERATE) && shortio && shortio.status===1 && shortio.apiKey && shortio.endpoint ? '':' d-none')}>
                                                                                    <label htmlFor="shortioUrlx" className="form-label">Create Short URL (Short.IO)</label>
                                                                                    <div className="form-check form-switch">
                                                                                        <input className="form-check-input" type="checkbox" name={'shortioUrlChecked['+n+']'} onChange={e => onShortioChecked(n, e.target.checked)} />
                                                                                        <label className="form-check-label" htmlFor="shortioUrl"></label>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div> : ''
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            }) : ''
                                    }
                                </> : ''
                        }
                        {
                            generateLoading ? <span className="spinner-grow spinner-grow-sm mt-2"></span> : ''
                        }

                    </div>
                </div>

            </div>
        </main>
    );
}